import React, { useState } from 'react';
import styled from '@emotion/styled';
import { color_shades_darker, color_colors_ocean, pale_grey, silver_two } from '../../constants/colors';
import ResponseVariableTestModal from './ResponseVariableTestModal';
import TooltipWrapper from './TooltipWrapper';

const testIcon = require('../../content/images/tab-icons/response-variables-blue.svg');

interface ResponseVariableTestButtonProps {
    /** The text value to test - this will be pre-populated in the modal */
    textValue?: string;
    /** Optional custom class name */
    className?: string;
    /** Optional tooltip text */
    tooltip?: string;
}

/**
 * A button that opens the Response Variable Test modal.
 * Use this next to text fields that support response variables to allow users to test them.
 * 
 * @example
 * <ResponseVariableTestButton textValue={myTextFieldValue} />
 */
const ResponseVariableTestButton: React.FC<ResponseVariableTestButtonProps> = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const button = (
        <TestButton 
            className={props.className}
            onClick={() => setIsModalOpen(true)}
            type="button"
            title={props.tooltip || "Test response variables"}
        >
            <img src={testIcon} alt="Test Variables" />
        </TestButton>
    );

    return (
        <>
            {props.tooltip ? (
                <TooltipWrapper text={props.tooltip} place="top">
                    {button}
                </TooltipWrapper>
            ) : button}
            
            <ResponseVariableTestModal
                isVisible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                initialText={props.textValue}
            />
        </>
    );
};

const TestButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 6px;
    border: 1px solid ${silver_two};
    background: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
    
    img {
        width: 18px;
        height: 18px;
    }
    
    &:hover {
        background: ${pale_grey};
        border-color: ${color_colors_ocean};
    }
`;

export default ResponseVariableTestButton;
